export enum Toggle {
  Tags = "showTags",
  Worlds = "showWorlds",
  Powers = "showPowers",
  BlitzModifiers = "showBlitzModifiers",
  Recommendations = "showRecommendations",
  Groups = "showGroups",
  Triggers = "showTriggers",
}
